import axiosInstance from "services/AxiosInstance";
import { TAnalyticsSummaryResponse } from "types";
import { TGetAnalyticsSummaryParams } from "types/Analytics/AnalyticsParams";

export const getSupplierAnalytics = async (params: TGetAnalyticsSummaryParams): Promise<TAnalyticsSummaryResponse> => {
  const { id } = params;
  const response = await axiosInstance.get(`/analytics/${id}/summary`, { params });
  return response.data;
};
